import * as RadixTooltip from "@radix-ui/react-tooltip";
import { Flex } from "../primitives/Flex";
import { styled } from "@pigment-css/react";
import { PercentageChip } from "../primitives/PercentageChip";

const HeadersContainer = styled("div")(() => ({
  display: "flex",
  gap: "0",
}));

const HeaderColumn = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.managementView.spacing[26],
  flex: 1,
}));

const HeaderTitle = styled("p")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[14],
  fontWeight: theme.managementView.font.weight[500],
  color: theme.managementView.colors.neutral[56],
  margin: 0,
}));

const HeaderValue = styled("p")(({ theme }) => ({
  fontFamily: theme.managementView.font.family,
  fontSize: theme.managementView.font.size[21],
  fontWeight: theme.managementView.font.weight[500],
  letterSpacing: theme.managementView.font.letterSpacing.tight,
  color: theme.managementView.colors.neutral[90],
  margin: 0,
}));

export interface KPIHeaderColumn {
  title: string;
  value: string | number;
  percentageChange?: number;
  changeTooltip?: string;
}

export interface KPIHeadersProps {
  columns: KPIHeaderColumn[];
}

export const KPIHeaders = ({ columns }: KPIHeadersProps) => {
  return (
    <RadixTooltip.Provider delayDuration={200}>
      <HeadersContainer>
        {columns.map((column, index) => {
          return (
            <HeaderColumn key={index}>
              <HeaderTitle>{column.title}</HeaderTitle>
              <Flex direction="column" gap={8} align="start">
                <HeaderValue>{column.value}</HeaderValue>
                {column.percentageChange !== undefined && (
                  <PercentageChip value={column.percentageChange} tooltip={column.changeTooltip} />
                )}
              </Flex>
            </HeaderColumn>
          );
        })}
      </HeadersContainer>
    </RadixTooltip.Provider>
  );
};
